// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bhr-total[data-v-093169da]{background:#f6f8fa;border-radius:6px;padding:12px 16px}.bhr-stat[data-v-093169da]{margin-bottom:4px;margin-right:28px}.bhr-l[data-v-093169da]{color:#6b6b6b;font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
